var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInitiative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27 57.383c1.459-.8 2.588-.226 3.23.586 5.414 7.187 11.147 8.638 14.5 9.563.318 2.207 3.35 8.263 10.252 8.263 4.602 0 7.78-2.552 9.533-7.656 6.146-1.154 9.07-4.169 10.493-5.438 1.424-1.269 2.643-1.555 3.51-.882.868.673 1.117 1.992.375 3.12-1.807 2.818-6.624 5.374-10.626 7.324l-.704.34c-2.074 1.025-3.048 1.815-3.048 4.26 0 1.38.236 2.375.707 2.987-1.15.1-2.315.15-3.492.15-15.34 0-28.663-8.635-35.374-21.31l-.185-.354c.14-.41.416-.727.828-.953z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.855 11.577l.151-.148c.19.082.367.202.535.36 1.212 1.14 1.014 2.392.44 3.253-5.162 7.37-4.77 13.271-4.614 16.746-2 .985-6.823 5.739-4.69 12.304 1.422 4.377 4.777 6.73 10.067 7.058 2.932 5.368 7.41 7.4 9.144 8.386l.112.065c1.647.961 1.487 1.54 1.115 2.573-.372 1.033-1.284 1.362-2.586 1.005-3.238-.848-7.054-4.27-10.146-7.474l-.358-.376c-1.758-1.835-3.067-2.921-5.481-2.137-1.353.44-2.227 1.053-2.623 1.84l.047.116A39.884 39.884 0 0 1 0 40c0-11.116 4.535-21.174 11.855-28.423z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.903 4.22l.018.115c.04.328-.022.658-.186.99-.737 1.492-1.991 1.669-2.982 1.372-8.558-2.782-14.087-.682-17.364.483l-.161-.162c-1.75-1.663-7.504-4.558-12.976-.726-3.77 2.64-4.864 6.635-3.28 11.987-4.373 4.47-5.205 8.482-5.643 10.338-.438 1.856-1.232 2.689-2.329 2.635-1.097-.054-1.743-.958-1.782-2.307-.136-3.344 1.952-8.08 4.11-11.974l.262-.467c1.211-2.213 1.676-3.804.223-5.88-.449-.64-.888-1.12-1.317-1.44l-.092.077A39.838 39.838 0 0 1 40 0a39.842 39.842 0 0 1 17.272 3.91l.63.31z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.972 5.932l.098.06C72.434 13.049 80 25.642 80 40c0 1.767-.115 3.508-.337 5.215l-.044.326c-.321.184-.685.25-1.093.197-1.652-.21-2.227-1.338-2.269-2.373-.156-8.997-3.94-13.54-6.11-16.26 1.04-1.972 2.148-8.653-3.437-12.71-3.723-2.706-7.843-2.54-12.36.496-5.651-2.678-9.86-2.039-11.757-1.849-1.897.19-2.665-.286-2.971-1.34-.306-1.055.186-1.67 1.45-2.146 3.117-1.218 8.544-.775 12.928 0l1.367.267c1.972.379 3.268.468 4.578-1.336.648-.892.99-1.743 1.027-2.555z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.362 30.523c.897-.633 1.938-.564 2.8.475 2.166 2.551 3.344 7.862 4.039 12.26l.085.54c.408 2.435 1.013 3.637 3.054 4.605 1.384.657 2.643.544 3.777-.34l.084-.07-.134.635c-3.446 15.673-16.082 27.9-31.971 30.745l-.238.04c-.432-.256-.702-.644-.81-1.163-.339-1.63.541-2.542 1.505-2.918 8.456-3.077 11.52-8.135 13.385-11.07 2.203.34 8.881-.788 10.9-7.39 1.345-4.4-.056-8.212-4.203-11.435.693-6.215-1.824-9.705-2.621-11.437-.798-1.732-.55-2.844.348-3.477z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.252 58.768a7 7 0 1 1 0 14 7 7 0 0 1 0-14z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 34a7 7 0 1 1 0 14 7 7 0 0 1 0-14z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 7.222a7 7 0 1 1 0 14 7 7 0 0 1 0-14z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 15.251a7 7 0 1 1 0 14 7 7 0 0 1 0-14z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.837 46.97a7 7 0 1 1 0 14 7 7 0 0 1 0-14z",
    opacity: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInitiative);
export default __webpack_public_path__ + "static/media/icon-initiative.0e2e82bb.svg";
export { ForwardRef as ReactComponent };